import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-profileqr',
  templateUrl: './profileqr.component.html',
  styleUrls: ['./profileqr.component.css'],
  host: {
    '[style.background-color]': 'backgroundColor'
  }
})
export class ProfileqrComponent implements OnInit, OnDestroy {
  urlname: any = "";

  //Save Validation
  submitted: boolean = false;
  successfully: boolean = false;
  saveloading: boolean = false;
  isEditMode = false;
  currentStep: 'login' | 'register' | 'details' | '404' = 'login';
  customerData: any;
  customerBO: any = [];
  synccode: any = "";
  storeBO: any = [];
  qrcodeBO: any = [];
  profileform = new FormGroup({
    mobileno: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/),]),
  });

  registerForm = new FormGroup({
    mobileno: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    customername: new FormControl('', [Validators.required]),
    emailid: new FormControl('', [Validators.email]),
  });

  routerEventSubscription = Subscription.EMPTY;

  constructor(private appService: DhukanDataService, public router: Router, private route: ActivatedRoute,
    public loginService: LoginDataService,
    private currentRoute: ActivatedRoute,
  ) {
    this.routerEventSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.fnGetUrlParameters();
      });
  }

  ngOnInit() {
    this.profileform.reset();
    this.fnInitializeQuestion();
    var storedData = localStorage.getItem('profileData');
    var urlSynccode = this.currentRoute.snapshot.paramMap.get('urlname') || '';

    if (storedData) {
      var { synccode: storedSynccode, mcustomerid, storesyncode: storedStoresyncode } = JSON.parse(storedData);

      if (storedSynccode === urlSynccode) {
        this.synccode = storedStoresyncode;
        if (mcustomerid) {
          this.getCustomerDetails(mcustomerid);
        }
      }
      else {
        localStorage.removeItem('profileData');
        this.fnGetUrlParameters();
      }
    }
  }

  fnInitializeQuestion() {
    this.profileform.setValue({
      mobileno: null,
    });
  }

  ngOnDestroy(): void {
    if (this.routerEventSubscription !== undefined) {
      this.routerEventSubscription.unsubscribe();
    }
  }

  get backgroundColor() {
    return this.qrcodeBO?.themecolor || '#01999f';
  }

  fnGetUrlParameters() {
    this.urlname = this.currentRoute.snapshot.paramMap.get('urlname') || '';
    if (this.urlname) this.fnGetStoreSyncCode();
  }

  fnGetStoreSyncCode() {
    var data = { qrcodetxt: this.urlname, formname: 'ProfileQR' };
    this.appService.getStoreSynccode(data).subscribe(
      (res) => {
        var body = res.json();
        if (body.status === 200) {
          var result = body.result;
          var checkmsg = ""
          if (result.length > 0) {
            checkmsg = result[0][0].checkmsg
          }
          if (checkmsg === 'Done') {
            this.storeBO = result[1][0];
            this.qrcodeBO = result[2][0];
            console.log(this.storeBO);
            this.synccode = result?.[1]?.[0]?.synccode || '';
            if (!this.synccode) {
              this.currentStep = '404';
            }
          } else {

            this.currentStep = '404';

          }


        } else {
          this.currentStep = '404';
        }
      },
      () => this.currentStep = '404'
    );
  }

  fnCheckCustomerBySyncCode() {
    var mobileno = this.profileform.get('mobileno')?.value;
    var data: any = { synccode: this.synccode, mobileno };
    this.saveloading = true;

    this.appService.CheckCustomer(data).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();
        if (body.status === 200) {
          var checkmsg = body.result[0].checkmsg;
          if (checkmsg === 'New') {
            this.currentStep = 'register';
            this.registerForm.patchValue({ mobileno });
            this.registerForm.get('mobileno')?.disable();
          } else if (checkmsg === 'Exist') {
            var customerid = body.result[0].mcustomerid;
            this.customerData = { ...body.result[0] };
            var storageData = {
              synccode: this.urlname,
              storesyncode: this.synccode,
              mcustomerid: customerid
            };
            localStorage.setItem('profileData', JSON.stringify(storageData));
            this.getCustomerDetails(customerid);
            this.fnGetStoreSyncCode();

          } else {
            this.currentStep = '404';
          }
        } else {
          this.currentStep = '404';
        }
      },
      (error) => {
        this.saveloading = false;
        this.currentStep = '404';
      }
    );
  }
  getCustomerDetails(customerid: any) {
    var data = { customerid, synccode: this.synccode };
    this.saveloading = true;
    this.appService.getCustomerse(data).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();
        if (body.status === 200) {
          this.customerData = body.result[0];
          this.currentStep = 'details';
        } else {
          this.currentStep = '404';
        }
      },
      (err) => {
        this.saveloading = false;
        this.currentStep = '404';
      }
    );
  }
  fnRegisterSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) return;
    var customerData = this.registerForm.getRawValue();
    var payload = { ...customerData, synccode: this.synccode, qrcodetxt: this.urlname };
    this.saveloading = true;
    this.appService.InsertCustomerse(payload).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();
        if (body.status === 200) {
          var customerid = body.result?.[0]?.mcustomerid;
          if (customerid) {
            var storageData = {
              synccode: this.urlname,
              storesyncode: this.synccode,
              mcustomerid: customerid
            };
            localStorage.setItem('profileData', JSON.stringify(storageData));
            this.getCustomerDetails(customerid);
          } else {
            this.currentStep = '404';
          }
        } else {
          this.currentStep = '404';
        }
      },
      (err) => {
        this.saveloading = false;
        this.currentStep = '404';
      }
    );
  }

  onEditProfile() {
    this.isEditMode = true;
    if (this.customerData) {
      this.registerForm.patchValue(this.customerData);
      this.registerForm.get('mobileno')?.disable();
    }
  }

  closePopup() {
    this.isEditMode = false;
  }

  saveProfile() {
    if (this.registerForm.invalid) {
      this.submitted = true;
      return;
    }
    var updatedData = this.registerForm.getRawValue();
    var storedData = localStorage.getItem('profileData');
    let customerid = null;
    if (storedData) {
      const parsed = JSON.parse(storedData);
      customerid = parsed?.mcustomerid;
    }
    var payload = {
      ...updatedData,
      customerid: customerid,
      synccode: this.synccode
    };

    this.saveloading = true;
    this.appService.setCustomer(payload).subscribe(
      (res: any) => {
        this.saveloading = false;
        var body = res.json();
        if (body.status === 200) {
          this.customerData = { ...body.result[0] };
          this.isEditMode = false;
          this.getCustomerDetails(customerid);
        }
      },
      (err) => {
        this.saveloading = false;
      }
    );
  }
  onLogout() {
    localStorage.removeItem('profileData');
    this.customerData = null;
    this.currentStep = 'login';
    this.profileform.reset();
    this.registerForm.reset();
    this.submitted = false;
    this.isEditMode = false;
  }
}

